import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import worldMap from './world-110m.json'; // Caminho para o GeoJSON do mapa do mundo


const TerritoryView = () => {
  const [territories, setTerritories] = useState([]);
  const [selectedTerritoryId, setSelectedTerritoryId] = useState(null);
  const [countries, setCountries] = useState([]);
  const [selectedCountryIds, setSelectedCountryIds] = useState([]);
  

  useEffect(() => {
    const loadTerritories = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_TERRITORY_LIST);
        if (!response.ok) {
          throw new Error('Dados não puderam ser carregados');
        }
        let data = await response.json();
        data = data.sort((a, b) => a.name.localeCompare(b.name));
        const result = data.filter(terr=>terr.countries.length>0)
        setTerritories(result);
      } catch (error) {
        console.error("Erro ao buscar territórios:", error);
      }
    };

    loadTerritories();
  }, []);

  useEffect(() => {
    if (selectedTerritoryId) {
      const territory = territories.find(t => t.id === selectedTerritoryId);
      setSelectedCountryIds(territory ? territory.countries.map(c => c.numericCode.toString().padStart(3, '0')) : []);    
      console.log(selectedCountryIds);
    }
  }, [selectedTerritoryId, territories]);

  const handleTerritoryChange = (e) => {
    const territoryId = e.value;
    const territory = territories.find(t => t.id === territoryId);
    setSelectedTerritoryId(territoryId);
    setCountries(territory ? territory.countries : []);
  };

  return (
    <div>
      <Dropdown 
        value={selectedTerritoryId} 
        options={territories} 
        onChange={handleTerritoryChange} 
        optionLabel="name" 
        placeholder="Select a territory"
        optionValue="id"
      />
      <p>Countries: {countries.map(country => country.name).join(', ')}</p>
      <ComposableMap width={800} height={350}>
        <Geographies geography={worldMap}>
          {({ geographies }) =>
            geographies.map(geo => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill={selectedCountryIds.includes(geo.id) ? '#F53' : '#DDD'}
              />
            ))
          }
        </Geographies>
      </ComposableMap>
    </div>
  );
};

export default TerritoryView;
